import React, {ReactNode} from "react";

import styles from "./CustomSwitchFieldWithTitle.module.css"
import {RootState} from "../../../app/store";
import {useAppSelector} from "../../../app/hooks";
import {CustomSwitchField} from "../customSwitchField/CustomSwitchField";
import classnames from "classnames";
import {WhiteTooltip} from "../tooltip/WhiteTooltip";

interface FieldProps {
    title: string
    textOnTrue: string
    textOnFalse: string
    description: string
    valueSelector: (state: RootState) => boolean | undefined;
    toggleValue: (v: boolean) => void
    disabled?: boolean
    tooltip?: ReactNode
}

export const CustomSwitchFieldWithTitle: React.FC<FieldProps> = ({
                                                                     title,
                                                                     textOnTrue,
                                                                     textOnFalse,
                                                                     description,
                                                                     valueSelector,
                                                                     toggleValue,
                                                                     disabled = false,
                                                                     tooltip
                                                                 }) => {

    const value = useAppSelector(valueSelector)

    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={classnames(styles.title, disabled && styles.disabled)}>
                {title}
                {tooltip && <WhiteTooltip title={<span className={styles.tooltipText}>{tooltip}</span>}>
                    <span className={styles.tooltipIcon} aria-label={`${title} help`} tabIndex={0}>?</span>
                </WhiteTooltip>}
            </span>
            <span className={classnames(styles.description, disabled && styles.disabled)}>{description}</span>
        </div>
        <CustomSwitchField
            textOnTrue={textOnTrue}
            textOnFalse={textOnFalse}
            value={value}
            toggleValue={toggleValue}
            disabled={disabled}
        />
    </div>
}
